import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { shape, bool as boolType, string as stringType } from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';

const CollectionsImage = ({ metadata, firstProductMedia, isMobile, experienceName }) => {
  const firstProductImage = firstProductMedia?.images[0].url.replace(/<SIZE>/g, '600');

  return (
    <div>
      {!experienceName && (
        <div className="pipcollectionImage">
          {metadata?.collectionImageUrl ? (
            <Image
              src={metadata?.collectionImageUrl}
              alt="main-product-image"
              height="300"
              width="300"
              data-testid="anchor-image"
              className="sui-w-full"
            />
          ) : (
            <Image
              src={firstProductImage}
              aria-label="firstProductImage"
              alt="first-product-image"
              height="300"
              width="300"
              className="sui-w-full"
            />
          )}
        </div>
      )}

      {/* Disable bullet description for hd-home */}
      {!experienceName && (
        <div className="sui-leading-normal sui-font-regular sui-text-sm sui-pt-2 sui-pl-4">
          {/* eslint-disable-next-line react/no-danger */}
          <ul
            dangerouslySetInnerHTML={{ __html: metadata?.collectionDesc.replace(/<li> /g, '<li class=\'sui-pt-2\'>') }}
            className="sui-list-disc sui-ml-4"
          />
        </div>
      )}

      {/* Disable collection link for hd-home */}
      {(!experienceName && metadata?.collectionPlpUrl) && (
        <div className="sui-pt-5 sui-pb-5 sui-text-sm sui-text-info">
          <Link
            href={metadata?.collectionPlpUrl}
            target={isMobile ? '_self' : '_blank'}
            rel="noreferrer"
            data-testid="tooltip-product"
          >Shop {metadata?.collectionName}
          </Link>
        </div>
      )}
    </div>
  );
};

CollectionsImage.propTypes = {
  metadata: shape({
  }),
  firstProductMedia: shape({
  }),
  isMobile: boolType,
  experienceName: stringType
};

CollectionsImage.defaultProps = {
  metadata: {},
  firstProductMedia: {},
  isMobile: false,
  experienceName: ''
};

export default CollectionsImage;